import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useIntl } from 'react-intl'
import { LinkContainer } from 'react-router-bootstrap'
import classNames from 'classnames'

import { authActions } from '../../actions/authActions'

import { ReactComponent as Logo } from '../../assets/logo.svg'
import TFLogo from '../../assets/tf.png'
import LeagueLogo from '../../assets/lp_experience.png'

import styles from './NavigationBar.module.scss'

const NavigationBar = () => {
  const dispatch = useDispatch()
  const [selectedTab, setSelectedTab] = useState(null)

  const { formatMessage: f } = useIntl()

  const handleLogout = (e) => {
    e.preventDefault()
    dispatch(authActions.logout())
  }

  const handleDismiss = () => {
    setSelectedTab(null)
  }

  return (
    <header>
      <div className={styles.navbar}>
        <LinkContainer to="/">
          <button className={styles.brand}>
            <Logo style={{ width: "200px", height: "50px" }} />
            <div style={{margin: ".5rem", border: "solid .5px #fff", height: "30px"}} />
            <img src={TFLogo} alt='' style={{ width: "40px" }} />
            <div style={{margin: ".5rem", border: "solid .5px #fff", height: "30px"}} />
            <img src={LeagueLogo} alt='' style={{ width: "40px" }} />
          </button>
        </LinkContainer>
      </div>
      <div
        data-testid="links-container"
        className={classNames(
          styles.sidebar,
          selectedTab !== 'settings' ? styles.hidden : '',
        )}
      >
        <div className={styles.linkContainer}>
          <button onClick={handleLogout}>
            {f({ id: 'navbar.logout' })}
          </button>
        </div>
      </div>
      <div
        onClick={handleDismiss}
        className={classNames(
          styles.darkenBottom,
          !selectedTab ? styles.hidden : '',
        )}
      />
      <div
        onClick={handleDismiss}
        className={classNames(
          styles.darkenNavbar,
          !selectedTab ? styles.hidden : '',
        )}
      />
    </header>
  )
}

export default NavigationBar
